/**
 * Per-project LLM config HTTP service (PX-W6.5) — the llm-config pair
 * re-homed on ProjectController at W1.5 R4.
 *
 * ⚠ The GET answers MASKED `apiKey` rows; the PUT stores the body's key
 * verbatim (INV-2) and answers the saved row masked. See `../llmKeyPolicy.ts`
 * for the client-side guard that keeps the masked value out of the PUT body.
 */

import { apiClient } from '@/services'

import type { LlmConfig, LlmConfigInput } from '../types'

export const llmConfigService = {
  /** Every agent-type row for the project, keys masked. */
  list(projectId: string): Promise<LlmConfig[]> {
    return apiClient.get<LlmConfig[]>(
      `/{orgId}/projects/${encodeURIComponent(projectId)}/llm-config`
    )
  },

  /** Create or update ONE (project, agentType) row; answers masked. */
  save(projectId: string, input: LlmConfigInput): Promise<LlmConfig> {
    return apiClient.put<LlmConfig>(
      `/{orgId}/projects/${encodeURIComponent(projectId)}/llm-config`,
      input
    )
  }
}
